module.exports = __webpack_public_path__ + "static/img/dzbapp_ios.4102b1b4.png";